// src/components/LoadingBar.js — Top-of-page gold progress bar
import React, { useState, useCallback, createContext, useContext } from "react";

const LoadingContext = createContext();
export const useLoading = () => useContext(LoadingContext);

export function LoadingProvider({ children }) {
  const [loading, setLoading] = useState(false);
  const start = useCallback(() => setLoading(true), []);
  const stop = useCallback(() => setLoading(false), []);

  return (
    <LoadingContext.Provider value={{ loading, start, stop }}>
      {loading && <div className="top-loading-bar" />}
      {children}
    </LoadingContext.Provider>
  );
}
